export class ResultDomain<T>
{
    count: number;
    value: T[];
}
